import { StateInterface } from "./state";
import { ProjectModel } from "../models";
import Vue from "vue";
import { FileEntryModel } from "../models/fileEntry";

export const setProjectsHandle = "setProjects";
export const setSubscriptionsHandle = "setSubscriptions";
export const setProjectHandle = "setProject";
export const setFileEntriesProjectHandle = "setFileEntriesForBuyProject";

export default {
  [setProjectsHandle](state: StateInterface, projects: ProjectModel[]): void {
    state.projects = projects;
  },
  [setSubscriptionsHandle](
    state: StateInterface,
    projects: ProjectModel[]
  ): void {
    state.subscriptions = projects;
  },
  [setProjectHandle](state: StateInterface, project: ProjectModel): void {
    Vue.set(state.project, project.projectId, project);
  },
  [setFileEntriesProjectHandle](
    state: StateInterface,
    entries: FileEntryModel[]
  ): void {
    if (entries.length > 0)
      Vue.set(state.fileEntriesForProjects, entries[0].project_id, entries);
  },
};
